import React from "react"
// MUI
import {Button, Grid, Typography} from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
// style
import {style} from "./style"

export default function QRCodePhone(props: any) {
    return (
        <Grid item xs={12} sx={style.mainWrapper}>
            <Grid container spacing={2} justifyItems={'center'} justifyContent={'center'}>
                <Grid item xs={6} md={4} sx={style.phoneWrapper}>
                    <Typography variant={"body1"} sx={style.phoneText}>
                        {props.fieldDisplay.phone}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant={'contained'}
                        sx={style.button}
                        href={`tel:${props.fieldDisplay.phone}`}
                        target={'_blank'}
                    >
                        <ArrowForwardIcon style={style.icon}/>
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
